//ROLES
export const ROLES = "roles/list";
export const ADD_ROLE = "roles/add";
export const ASSIGN_ROLE = "roles/role-user";
export const UPDATE_ROLE = "roles/update";
export const REMOVE_ROLE = "roles/remove";
export const SHOW_ROLE = "roles/show";
export const ASSIGN_PERMISSION = "roles/role-permission";

//PERMISSIONS
export const PERMISSIONS = "permissions/list";
export const ADD_PERMISSION = "permissions/add";
export const UPDATE_PERMISSION = "permissions/update";
export const REMOVE_PERMISSION = "permissions/remove";
export const SHOW_PERMISSION = "permissions/show";

//MODULES
export const MODULES_LIST = "modules/list";
export const MODULES_SEARCH = "modules/search";
export const SHOW_MODULE = "modules/show";
export const ADD_MODULE = "modules/add";
export const UPDATE_MODULE = "modules/update";
export const REMOVE_MODULE = "modules/remove";

//SCREENS
export const SCREENS_LIST = "screens/list";
export const SHOW_SCREEN = "screens/show";
export const ADD_SCREEN = "screens/add";
export const UPDATE_SCREEN = "screens/update";
export const REMOVE_SCREEN = "screens/remove";

//SCREEN SECTIONS
export const SCREEN_SECTION_LIST = "screen-sections/list";
export const ADD_SCREEN_SECTION = "screen-sections/add";
export const UPDATE_SCREEN_SECTION = "screen-sections/update";
export const REMOVE_SCREEN_SECTION = "screen-sections/remove";

//COUNTRIES
export const COUNTRIES_SEARCH = "countries/search";
export const SHOW_COUNTRY = "countries/show";
export const ADD_COUNTRY = "countries/add";
export const UPDATE_COUNTRY = "countries/update";
export const REMOVE_COUNTRY = "countries/remove";

//CITIES
export const CITIES_SEARCH = "cities/search";
export const SHOW_CITY = "cities/show";
export const ADD_CITY = "cities/add";
export const UPDATE_CITY = "cities/update";
export const REMOVE_CITY = "cities/remove";

//DISTRICTS
export const DISTRICTS_SEARCH = "districts/search";
export const SHOW_DISTRICT = "districts/show";
export const ADD_DISTRICT = "districts/add";
export const UPDATE_DISTRICT = "districts/update";
export const REMOVE_DISTRICT = "districts/remove";

//SUBDISTRICTS
export const SUBDISTRICTS_SEARCH = "sub-districts/search";
export const SHOW_SUBDISTRICT = "sub-districts/show";
export const ADD_SUBDISTRICT = "sub-districts/add";
export const UPDATE_SUBDISTRICT = "sub-districts/update";
export const REMOVE_SUBDISTRICT = "sub-districts/remove";

//LANGUAGES
export const LANGUAGES_SEARCH = "languages/search";
export const SHOW_LANGUAGE = "languages/show";
export const ADD_LANGUAGE = "languages/add";
export const UPDATE_LANGUAGE = "languages/update";
export const REMOVE_LANGUAGE = "languages/remove";

//Reasons
export const REASONS_SEARCH = "text/search";
export const SHOW_REASON = "text/show";
export const ADD_REASON = "text/add";
export const UPDATE_REASON = "text/update";
export const REMOVE_REASON = "text/remove";

//Delivery Types
export const DELIVERY_TYPE_SEARCH = "delivery-types/search";
export const SHOW_DELIVERY_TYPE = "delivery-types/show";
export const ADD_DELIVERY_TYPE = "delivery-types/add"; 
export const UPDATE_DELIVERY_TYPE = "delivery-types/update";
export const REMOVE_DELIVERY_TYPE = "delivery-types/remove";

//Tasks
export const TASKS_SEARCH = "tasks/search";
export const SHOW_TASK = "tasks/show";
export const ADD_TASK = "tasks/add";
export const UPDATE_TASK = "tasks/update";
export const UPDATE_TASK_ORDER = "tasks/update-taskorder";
export const REMOVE_TASK = "tasks/remove";

export const LIST_DRIVER_TASK = "tasks/task-mobile";
export const FINISH_DRIVER_TASK = "driver/task/finish";
export const DRIVER_WALLET_DETAILS = "drivers/wallet-details";

//CATEGORIES
export const CATEGORIES_SEARCH = "categories/search";
export const SHOW_CATEGORY = "categories/show";
export const ADD_CATEGORY = "categories/add";
export const UPDATE_CATEGORY = "categories/update";
export const REMOVE_CATEGORY = "categories/remove";

//BANNERS
export const BANNERS_SEARCH = "banners/search";
export const SHOW_BANNER = "banners/show";
export const ADD_BANNER = "banners/add";
export const UPDATE_BANNER = "banners/update";
export const REMOVE_BANNER = "banners/remove";

//OFFERS
export const OFFERS_SEARCH = "offers/search";
export const SHOW_OFFER = "offers/show";
export const ADD_OFFER = "offers/add";
export const UPDATE_OFFER = "offers/update";
export const REMOVE_OFFER = "offers/remove";

//TICKETS
export const TICKETS_SEARCH = "tickets/search";
export const SHOW_TICKET = "tickets/show";

//GENERAL
export const GENERAL_STARTUP = "general/startup";
export const UPDATE_STARTUP = "applications/update";

//EXPRESS DELIVERY SETTINGS
export const GET_EXPRESS_DELIVERY_SETTINGS = "express-delivery-settings/show";
export const UPDATE_EXPRESS_DELIVERY_SETTINGS = "express-delivery-settings/update";

//TEXT
export const ADD_TEXT = "text/add";
export const SHOW_TEXT = "text/show";

//TERMS
export const TERMS_LIST = "general/terms";
export const UPDATE_TERM = "general/terms-update";

//Pricay Policy
export const POLICY_LIST = "general/privacy-policy";
export const UPDATE_POLICY = "general/privacy-policy-update";

//FAQS
export const FAQ_LIST = "general/faq";
export const UPDATE_FAQ = "general/faq-update";


//USERS
export const USERS_SEARCH = "users/search";
export const USERS_LIST = "users/list";
export const SHOW_USER = "users/show";
export const ADD_USER = "users/add";
export const ADD_CUSTOMER = "users/add-customer";
export const UPDATE_USER = "users/update";
export const REMOVE_USER = "users/remove";

//ADDRESSES
export const ADDRESS_SEARCH = "addresses/search";
export const ADDRESS_LIST = "addresses/list";
export const ADDRESS_TYPE = "addresses/filter";
export const SHOW_ADDRESS = "addresses/show";
export const ADD_ADDRESS = "addresses/add";
export const UPDATE_ADDRESS = "addresses/update";
export const REMOVE_ADDRESS = "addresses/remove";

//VEHICLES
export const VEHICLES_SEARCH = "vehicles/search";
export const SHOW_VEHICLE = "vehicles/show";
export const ADD_VEHICLE = "vehicles/add";
export const UPDATE_VEHICLE = "vehicles/update";
export const REMOVE_VEHICLE = "vehicles/remove";
export const VEHICLE_ASSIGN_DRIVER = "vehicles/assign-driver";
export const VEHICLE_CHECK_ALLOCATED = "vehicles/check-allocated";

//VEHICLE CATEGORIES
export const VEHICLE_CATEGORY_SEARCH = "vehicle-category/search";
export const SHOW_VEHICLE_CATEGORY = "vehicle-category/show";
export const ADD_VEHICLE_CATEGORY = "vehicle-category/add";
export const UPDATE_VEHICLE_CATEGORY = "vehicle-category/update";
export const REMOVE_VEHICLE_CATEGORY = "vehicle-category/remove";

//SHIPMENT TYPES
export const SHIPMENT_TYPES_SEARCH = "shipment-type/search";
export const SHOW_SHIPMENT_TYPE = "shipment-type/show";
export const ADD_SHIPMENT_TYPE = "shipment-type/add";
export const UPDATE_SHIPMENT_TYPE = "shipment-type/update";
export const REMOVE_SHIPMENT_TYPE = "shipment-type/remove";

export const STATUS_SEARCH = "status/search";
export const SHOW_STATUS = "status/show";
export const ADD_STATUS = "status/add";
export const UPDATE_STATUS = "status/update";
export const REMOVE_STATUS = "status/remove";

//DRIVERS
export const DRIVERS_SEARCH = "drivers/search";
export const ADD_DRIVER = "drivers/add";
export const ASSIGN_DELIVERY_TYPE_ACTIVATE = "drivers/active-delivery";
export const UPDATE_DRIVER_PARTNERBRANCHES = "drivers/update-partnerbranches";
export const ADD_DOCUMENT_FILE = "documents/add-file";
export const ADD_DRIVER_DOCUMENT = "documents/add-for-driver";
export const ADD_VEHICLE_DOCUMENT = "documents/add-for-vehicle";
export const UPDATE_DOCUMENT = "documents/update";
export const UPDATE_DOCUMENT_STATUS = "documents/update-status";
export const ADD_DRIVER_FULL = "drivers/add-driver";
export const UPDATE_DRIVER = "drivers/update";
export const UPDATE_DRIVER_DRIVER_TYPE = "drivers/update-type";
export const SHOW_DRIVER = "drivers/show";
export const REMOVE_DRIVER = "drivers/remove";
export const UPDATE_DRIVER_CONTROL = "drivers/update-control";
export const NEAREST_EXPRESS_DRIVER = "drivers/nearest-express-driver";
export const EXPRESS_DRIVER_ROUTE = "drivers/express-driver-route";

//DRIVER TYPES
export const DRIVER_TYPE_SEARCH = "driver-type/search";
export const SHOW_DRIVER_TYPE = "driver-type/show";
export const ADD_DRIVER_TYPE = "driver-type/add";
export const UPDATE_DRIVER_TYPE = "driver-type/update";
export const REMOVE_DRIVER_TYPE = "driver-type/remove";

//COLLECTORS
export const COLLECTOR_SEARCH = "collectors/search";
export const ADD_COLLECTOR = "collectors/add";
export const UPDATE_COLLECTOR = "collectors/update";
export const SHOW_COLLECTOR = "collectors/show";
export const REMOVE_COLLECTOR = "collectors/remove";
export const TRANSFER_DRIVER_WALLET = "collectors/transfer-driver-wallet";
export const CLEAR_COLLECTOR_WALLET = "collectors/clear-wallet";

//PARTNERS
export const PARTNERS_SEARCH = "partners/search";
export const ADD_PARTNER = "partners/add";
export const UPDATE_PARTNER = "partners/update";
export const SHOW_PARTNER = "partners/show";
export const REMOVE_PARTNER = "partners/remove";

//PARTNERS BRANCH
export const PARTNERS_BRANCH_SEARCH = "partner-branch/search";
export const PARTNERS_BRANCH_LIST = "partner-branch/list";
export const ADD_PARTNER_BRANCH = "partner-branch/add";
export const UPDATE_PARTNER_BRANCH = "partner-branch/update";
export const SHOW_PARTNER_BRANCH = "partner-branch/show";
export const REMOVE_PARTNER_BRANCH = "partner-branch/remove";

//TIME SLOT
export const SEARCH_TIMESLOT = "timeslots/search";
export const TIMESLOT_LIST = "timeslots/list";
export const ADD_TIMESLOT = "timeslots/add";
export const ADD_TIMESLOT_DET = "timeslot-detail/add";
export const SHOW_TIMESLOT = "timeslots/show";
export const UPDATE_TIMESLOT = "timeslots/update";
export const REMOVE_TIMESLOT = "timeslots/remove";
export const CHECK_TIMESLOT = "timeslots/check-date";

//TIME SLOT EXCEPTION
export const SEARCH_TIMESLOT_EXCEPTION = "timeslot-exception/search";
export const ADD_TIMESLOT_EXCEPTION = "timeslot-exception/add";
export const SHOW_TIMESLOT_EXCEPTION = "timeslot-exception/show";
export const UPDATE_TIMESLOT_EXCEPTION = "timeslot-exception/update";
export const REMOVE_TIMESLOT_EXCEPTION = "timeslot-exception/remove";

//PARTNERS BRANCH TIME SLOT
export const PARTNERS_BRANCH_SEARCH_TIMESLOT = "partner-branch-timeslot/list";
export const ADD_PARTNER_BRANCH_TIMESLOT = "partner-branch-timeslot/add";
export const SHOW_PARTNER_BRANCH_TIMESLOT = "partner-branch-timeslot/show";
export const UPDATE_PARTNER_BRANCH_TIMESLOT = "partner-branch-timeslot/update";
export const REMOVE_PARTNER_BRANCH_TIMESLOT = "partner-branch-timeslot/remove";

//ITEMS
export const ITEMS_SEARCH = "items/search";
export const SHOW_ITEM = "items/show";
export const ADD_ITEM = "items/add";
export const UPDATE_ITEM = "items/update";
export const REMOVE_ITEM = "items/remove";

//SERVICES
export const SERVICES_SEARCH = "services/search";
export const SHOW_SERVICE = "services/show";
export const ADD_SERVICE = "services/add";
export const UPDATE_SERVICE = "services/update";
export const REMOVE_SERVICE = "services/remove";

//ORDERS
export const ORDERS_SEARCH = "orders/search";
export const SHOW_ORDER = "orders/show";
export const ADD_ORDER = "orders/add";
export const UPDATE_ORDER = "orders/update";
export const REMOVE_ORDER = "orders/remove";
export const CANCEL_ORDER = "orders/cancel";
export const UNDO_CANCEL_ORDER = "orders/restore";
export const ORDER_STATS = "orders/order-stats";
export const UNFREEZ_ORDER = "orders/unfreeze";
export const CHANGE_ORDER_STATUS = "orders/change-status";
export const ASSIGN_ORDER_DRIVER = "orders/assign-driver";

//COLLECTIONHUBS
export const COLLHUB_SEARCH = "collect-hub/search";
export const SHOW_COLLHUB = "collect-hub/show";
export const ADD_COLLHUB = "collect-hub/add";
export const UPDATE_COLLHUB = "collect-hub/update";
export const REMOVE_COLLHUB = "collect-hub/remove";

//DIRECT DELIVERY
export const DIRECT_DELIVERY_LOGS = "direct-delivery/logs";
export const DIRECT_DELIVERY_RUN = "direct-delivery/run";
export const REMOVE_DIRECT_DELIVERY_LOG = "direct-delivery/remove";

//LOGGER
export const SHOW_LOGGER = "general/show-logger";
export const CLEAR_LOGGER = "general/clear-logger";
export const FREE_DRIVER = "general/free-driver";
export const FREE_ORDER = "general/free-order";

//ACTIVITY LOGS
export const SHOW_ACTIVITY_LOGS = "activity-logs/search";

// PAYMENT METHODS
export const PAYMENT_METHODS_SEARCH = "payment-methods/search";
export const ADD_PAYMENT_METHOD = "payment-methods/add";
export const UPDATE_PAYMENT_METHOD = "payment-methods/update";
export const REMOVE_PAYMENT_METHOD = "payment-methods/remove";
export const SHOW_PAYMENT_METHOD = "payment-methods/show";

// PAYMENT STATUSES
export const PAYMENT_STATUS_SEARCH = "payment-status/search";
export const ADD_PAYMENT_STATUS = "payment-status/add";
export const UPDATE_PAYMENT_STATUS = "payment-status/update";
export const REMOVE_PAYMENT_STATUS = "payment-status/remove";
export const SHOW_PAYMENT_STATUS = "payment-status/show";

export const ADD_DRIVER_PAYMENT = "driver/payment/add-payment";
export const UPLOAD_DRIVER_PAYMENT = "driver/payment/upload-payment-confirmation";

// EMERGENCY SUB TYPES
export const EMERGENCY_SUB_TYPES_SEARCH = "emergency-subtypes/search";
export const ADD_EMERGENCY_SUB_TYPES = "emergency-subtypes/add";
export const UPDATE_EMERGENCY_SUB_TYPES = "emergency-subtypes/update";
export const REMOVE_EMERGENCY_SUB_TYPES = "emergency-subtypes/remove";
export const SHOW_EMERGENCY_SUB_TYPES = "emergency-subtypes/show";

// EMERGENCY TYPES
export const EMERGENCY_TYPES_SEARCH = "emergency-types/search";
export const ADD_EMERGENCY_TYPES = "emergency-types/add";
export const UPDATE_EMERGENCY_TYPES = "emergency-types/update";
export const REMOVE_EMERGENCY_TYPES = "emergency-types/remove";
export const SHOW_EMERGENCY_TYPES = "emergency-types/show";

// DRIVER EMERGENCIES
export const DRIVER_EMERGENCIES_SEARCH = "emergency/search";
export const UPDATE_DRIVER_EMERGENCIES = "emergency/update";
export const REMOVE_DRIVER_EMERGENCIES = "emergency/remove";
export const SHOW_DRIVER_EMERGENCIES = "emergency/show";

// SMS LOGS
export const SMS_LOGS_LIST = "sms/list";
export const SHOW_SMS_LOG = "sms/show";

// ARTICLES
export const ARTICLES_SEARCH = "articles/search";
export const ADD_ARTICLES = "articles/add";
export const UPDATE_ARTICLE = "articles/update";
export const REMOVE_ARTICLE = "articles/remove";
export const SHOW_ARTICLE = "articles/show";


export const UPLOAD_FILE = "general/upload-image";
export const GOOGLE_LOCATION = "general/google-location-url";